import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { EvaluationRoleTopicWeight } from '../../../commonTypes/user.types';

const useHttpGetEvaluationRoleTopicWeightOnMount = (evaluationRoleId: any, topicIds: any) => {
    const userApi: UserApi = useContainer(UserApi);
    const [data, setData] = useState<EvaluationRoleTopicWeight[]>([]);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = userApi.getEvaluationRoleTopicWeight({
        params: { evaluationRoleId },
        body: { topicIds },
        onSuccess: res => setData(res.body),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        if (evaluationRoleId && topicIds) {
            exec();
            return abort;
        }
    }, [evaluationRoleId, topicIds]);
    return { isReady, data, exec };
};

export default useHttpGetEvaluationRoleTopicWeightOnMount;
